<template>
  <el-dialog
    width="340px"
    :visible.sync="userDialogVisi"
    :before-close="close"
    :close-on-click-modal="false"
  >
    <el-button type="text" class="editBtn" @click="editUserInfo">
      <i class="el-icon-edit"></i>
    </el-button>
    <div class="userInfo">
      <el-avatar
        v-if="userInfo.tenementUserAvatarUrl"
        :size="100"
        :src="userInfo.tenementUserAvatarUrl"
      />
      <svgIcon v-else icon-class="touxiang" class="touxiang" />
      <div class="name">{{ userInfo.tenementUserName }}</div>
      <div class="wrapping">
        <svgIcon icon-class="phone" />
        <div class="txt">{{ userInfo.phoneNumber }}</div>
      </div>
      <div class="wrapping">
        <svgIcon icon-class="email" />
        <div class="txt">{{ userInfo.email }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {

  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      userDialogVisi: state => state.user.userDialogVisi,
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    close() {
      this.$store.dispatch('user/setUserDialogVisi', false)
    },
    editUserInfo() {
      this.$store.dispatch('user/setUserEditDialogVisi', true)
    }

  }
}
</script>

<style lang="scss" scoped>
.editBtn{
    position: absolute;
    right: 50px;
    top: 12px;
}
.touxiang{
  font-size: 100px;
}
.userInfo{
    text-align: center;
    padding-bottom: 30px;
    .name{
        font-size: 20px;
        color: #000;
        padding-top: 30px;
        padding-bottom: 40px;
    }
    .wrapping{
        color: #666;
        font-size: 16px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 10px 30px;
        .txt{
            padding-left: 10px;
        }
    }
}
</style>
